import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

Vue.use(Vuex);

import ProfileStore from "@/store/profile";

const store: StoreOptions<any> = {
	state: {},
	modules: {
		profile: ProfileStore
	}
};

export default new Vuex.Store<any>(store);
